import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
  payment: string;
  name: string;
  jwt: string;
  isLogin: boolean;
  putData: any;
  putIsFetching: boolean;
  putError: boolean;
  pasarella: string;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false,
  payment: '',
  name: '',
  jwt: '',
  isLogin: false,
  putData: null,
  putIsFetching: false,
  putError: false,
  pasarella: ''
}

export const user = (state: State = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_USER_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.CREATE_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.CREATE_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.SET_USER_PAYMENT:
      return {
        ...state,
        payment: action.paymentType
      }
    case actionTypes.SET_USER_PASARELLA:
      return {
        ...state,
        pasarella: action.pasarellaType
      }
    case actionTypes.SET_USER_NAME:
      return {
        ...state,
        name: action.name
      }
    case actionTypes.SET_USER_TOKEN:
      return {
        ...state,
        name: action.token
      }
    case actionTypes.SET_USER_LOGIN:
      return {
        ...state,
        isLogin: action.isLogin
      }
    case actionTypes.PUT_USER_REQUEST:
      return {
        ...state,
        putIsFetching: true
      }
    case actionTypes.PUT_USER_FAILURE:
      return {
        ...state,
        putIsFetching: false,
        putError: true
      }
    case actionTypes.PUT_USER_SUCCESS:
      return {
        ...state,
        putIsFetching: false,
        putError: false,
        putData: action.data
      }
    default:
      return state;
  }
}
